module.exports = __webpack_public_path__ + "static/img/card-guides_off.b0bb2199.png";